import Alpine from 'alpinejs'

Alpine.store('nav', {
    open: false,
 
    toggle() {
        this.open = !this.open
    },
    close() {
        this.open = false
    },
    getHeight() {
        const header = document.getElementById('header')
        return header.offsetHeight
    }
})

Alpine.store('cart', {
    open: false,
    count: 0,
    items: [],
    subTotal: 0,
    total: 0,

    init() {
        this.fetchCart()
    },

    toggle() {
        this.open = !this.open
    },
    close() {
        this.open = false
    },
    setCount(value) {
        this.count = value
    },
    fetchCart() {
        fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(data => this.setItemsUpdateCart(data))
        .catch((error) => {
            console.error('Fetching cart error:', error)
        })
    },
    removeItem(id) {
        const pairedSampleProduct = this.items.find(item => item.properties?.paired_product_id === id)

        const formData = {
            updates: {}
        }

        formData.updates[id] = 0

        if (pairedSampleProduct) {
            formData.updates[pairedSampleProduct.id] = 0
        }

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => this.setItemsUpdateCart(data))
        .catch((error) => {
            console.error('Remove from cart error:', error)
        })
    },
    setItemsUpdateCart(cart) {
        try {
            this.items = cart.items
            this.subTotal = cart.items_subtotal_price
            this.total = cart.total_price
            this.count = cart.item_count
        } catch(error) {
            console.error('Set items and update count error:', error)
        }
    },
    setQuantity(id, quantity) {
        if (this.quantityLoading || quantity === 0) return

        this.quantityLoading = true

        const formData = {
            id: id.toString(),
            quantity: quantity
        }

        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            this.setItemsUpdateCart(data)
            this.quantityLoading = false
        })
        .catch((error) => {
            this.quantityLoading = false
            console.error('Set quantity error:', error)
        })
    },
    addToCart(quantity = 1, productId) {
        const formData = {
            items: [{
                id: productId,
                quantity: quantity
            }]
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => this.fetchCart())
        .catch((error) => {
            console.error('Add to cart error:', error)
        })
    }
})

Alpine.store('search', {
    isOpen: false,
    term: '',
 
    toggle() {
        this.isOpen = !this.isOpen
    },
    open() {
        this.isOpen = true
    },
    close() {
        this.isOpen = false
        this.term = ''
    }
})

Alpine.store('recoverPassword', {
    open: false,

    init() {
        const pathname = window.location.pathname 
        const hash = window.location.hash

        if (pathname === '/account/login' && hash === '#recover') {
            this.open = true
        }
    },
 
    toggle() {
        this.open = !this.open
    }
})
